import React from 'react';
import { Autocomplete, Tooltip, Typography } from 'seagull';
import styles from "./ServiceQboAutocomplete.module.scss";
import { matchSorter } from 'match-sorter';
const ServiceQboAutocomplete = _ref => {
  let {
    qboItems,
    selectedOption,
    isDisabled,
    hasError,
    onQboItemChange,
    testid,
    showQboMapPlaceHolder
  } = _ref;
  const isLoading = !qboItems;
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: isDisabled ? 'QuickBooks Online services can be mapped through the services library' : ''
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Autocomplete, {
    "data-testid": testid,
    value: selectedOption,
    options: qboItems || [],
    onChange: (_, newOption) => onQboItemChange(newOption),
    renderOption: option => {
      const {
        name
      } = option;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.qboItemOption
      }, /*#__PURE__*/React.createElement(Typography, {
        ellipsis: true
      }, name));
    },
    getOptionSelected: (option, value) => option.id == value.id,
    getOptionLabel: option => option.name,
    filterOptions: (options, _ref2) => {
      let {
        inputValue
      } = _ref2;
      const filteredItems = matchSorter(options, inputValue, {
        keys: ['name']
      });
      return filteredItems;
    },
    noOptionsText: "No QuickBooks services",
    loading: isLoading,
    disabled: isLoading || isDisabled,
    textFieldProps: {
      alwaysShrinkLabel: showQboMapPlaceHolder,
      label: 'QuickBooks Online mapping',
      placeholder: isLoading ? '' : 'Not mapped',
      error: hasError
    },
    selectOnFocus: true,
    disableClearable: false,
    multiple: false,
    freeSolo: false
  })));
};
export default ServiceQboAutocomplete;